import { Box, DataTable, Text } from 'grommet';
import { Checkmark, Close } from 'grommet-icons';

const UploadDataTable = ({ dataTableArray }) => {
    return (
        <DataTable
            columns={[
                {
                    property: 'filename',
                    header: <Text>File Name</Text>,
                    render: (datum) => (
                        <Text>{datum.filename}</Text>
                    )
                },
                {
                    property: 'status',
                    header: <Text>Status</Text>,
                    render: (datum) => (
                        <Box>
                            { datum.status && <Checkmark color='green'/> }
                            { !datum.status && <Close color='red'/> }
                        </Box>
                    )
                },
                {
                    property: 'code',
                    header: <Text>Code</Text>,
                    render: (datum) => (
                        <Text>{datum.code}</Text>
                    )
                },
                {
                    property: 'message',
                    header: <Text>Message</Text>,
                    render: (datum) => (
                        <Text>{datum.message}</Text>
                    )
                }
            ]}
            data={dataTableArray}
        />
    )
}

export default UploadDataTable;